import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import styles from './InlineButton.scss';

const InlineButton = ({
  e2e,
  iconClassName,
  className,
  onClick = noop,
  size = 12,
}) => (
  <div
    data-e2e={e2e}
    className={cx(styles.button, className)}
    onClick={onClick}
    style={{ font: `${size}px` }}
  >
    <i className={cx(iconClassName)} />
  </div>
);

InlineButton.propTypes = {
  e2e: PropTypes.string,
  iconClassName: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.number,
};

export default InlineButton;
